<template>
  <div :class="['base-badge', 'theme-' + theme]">
    <div class="text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    theme: {
      type: String,
      default: 'green'
    }
  }
}
</script>

<style lang="scss" scoped>
.base-badge {
  position: relative;
  display: inline-block;
  font-size: 1.4rem;
  font-weight: var(--fw-medium);
  padding: 0.2rem 0.8rem;
  border: var(--border-1);
  border-radius: var(--br-1);
  border-color: var(--color-transparent);
  transition: all 0.2s;
}
.theme-white {
  color: var(--color-gray-3);
  background: var(--color-white-1);
}
.theme-green {
  color: var(--color-green-3);
  background: var(--color-green-2);
}
.theme-red {
  color: var(--color-white-1);
  background: var(--color-red-1);
}
.theme-purple {
  color: var(--color-white-1);
  background: var(--color-purple-1);
}
.theme-gray {
  color: var(--color-gray-3);
  background: var(--color-gray-2);
}
</style>
